module.exports = __webpack_public_path__ + "img/头图.a0877c70.png";